/* eslint eqeqeq: "off" */
//import React, { Component, createRef } from 'react'
import React, { Component } from 'react';
import {connect} from 'react-redux';
import {useState} from 'react';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import {  useLocation, useNavigate  } from "react-router-dom";
import {  useParams } from "react-router-dom";
import { Segment} from 'semantic-ui-react'; 
import {usuarioActual} from '../../util';
import withRouter from '../common/withRouter';
import Pago from './Pago';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as infoActions from '../../actions/infoActions';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as validations from '../../validations/validations';
import * as tagActions from '../../actions/tagActions';
import * as cursoActions from '../../actions/cursoActions';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment'; 
import $ from 'jquery';




class ManagePago extends React.Component {

  //  contextRef = createRef();

    constructor(props, context){
		super(props, context);
     
        
     
		this.state={
            errors:{},
            curso:{},
            permisos:{},
            
			tag:{
                    },
            pagos: [
               {
                    id: 1,
                    url:"/pago/",               
                    image: '/images/inmunohematologia.jpg',
                    imageBg: '/images/inmunohematologia.jpg',
                    title: 'Segundo Diplomado en Inmunohematología',
                    desc:"Mi descripcnp ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque"+
                          "et euismod ligula. Morbi mattis pretium eros, ut mollis leo tempus"+
                          "eget. Sed in dui ac ipsum feugiat ultricies. Phasellus vestibulum enim"+
                          "quis quam congue, non fringilla orci placerat. Praesent sollicitudin"
                  },
                  {
                    id: 2,
                    url:"/pago/",   
                    image: '/images/Diplomado4.jpeg',
                    imageBg: '/images/Diplomado4.jpeg',
                    title: '4to. Diplomado Internacional en Control de la Calidad Analítica'
                  ,
                    desc:"Mi descripcnp ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque"+
                          "et euismod ligula. Morbi mattis pretium eros, ut mollis leo tempus"+
                          "eget. Sed in dui ac ipsum feugiat ultricies. Phasellus vestibulum enim"+
                          "quis quam congue, non fringilla orci placerat. Praesent sollicitudin"

                  },
                  {
                    id: 3,
                    url:"/pago/",   
                    image: '/images/tpss.jpg',
                    imageBg: '/images/tpss.jpg',
                    title: 'Taller de Planificación de Control de Calidad Six Sigma para Laboratorio Adilab',

                    desc:"Mi descripcnp ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque"+
                          "et euismod ligula. Morbi mattis pretium eros, ut mollis leo tempus"+
                          "eget. Sed in dui ac ipsum feugiat ultricies. Phasellus vestibulum enim"+
                          "quis quam congue, non fringilla orci placerat. Praesent sollicitudin"

                  }
            ]
		};
		
	}
    
    onAcordionModulo=(id)=>{
        let pago=this.state.pago;
        let modulos=pago.modulos;
        for(let i=0; i<modulos.length; i++){
            if(modulos[i].id==id){
                if(modulos[i].activo==null)
                    modulos[i].activo=true;
                else
                    modulos[i].activo=!modulos[i].activo;
            }
        }
        this.setState({"pago":pago});
    }
    
    
    componentDidMount(){
        window.scrollTo(0, 0);
        usuarioActual(this, "home",false);
        
          if(this.props.user==null){
            
            let pageInfo={
                page:"home",
                idioma:this.props.idioma   
            };
            this.props.infoActions.getInfo(pageInfo).then( (paginaInfo)=>{
                   
                  })
            .catch(error=>{
              toastr.error(error);
            }); 
            
        }
     

		let id=this.props.id;
        
        if(id && id>0 ){
            this.props.infoActions.getCursoDetalleInfo(id).then( (cursoDetalle)=>{

            this.setState({"curso":cursoDetalle});  
            
            }).catch(error=>{
                toastr.error(error);
            }); 
        }
        
    }
    

    handleChange=(event, data)=> {

        let tag = this.state.tag;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		tag[field[0]]= value;
		else{
             if(!tag[field[0]]){
                    tag[field[0]]={}
                }
			tag[field[0]][field[1]]= value;
		}
        
		
        this.setState({"tag": tag});
    }
    
    
    



    onInscribir=(event)=>{
        
        
        this.props.cursoActions.inscribir(this.props.id, this.props.user).then( ()=>{ 
           toastr.success("Inscripción procesada!!!.");
            //this.props.history.push('/miespacio');
            this.props.navigate('/miespacio');
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
        
    }
    
    
     onInscribir=(tipo)=>{
        //console.log(tipo);
        
        this.props.cursoActions.inscribir(this.props.id, tipo, this.props.user).then( ()=>{ 
            
         if(tipo==1){    
            
           toastr.success("Inscripción realziada correctamente!!!.");
           this.props.navigate('/miespacio');     
        }else{
            
            toastr.success("Inscripción realziada correctamente!!! Completa el pago para tenera acceso");
            this.props.navigate('/pagolinea');
        }     
            //this.props.history.push('/miespacio');
            
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
        
    }
     
  
       
    render() {	
          
       return (
              <div >
                <Pago 
                    pagos={this.state.pago}
                    curso={this.state.curso}
                    onInscribir={this.onInscribir}
                    strings={this.props.strings}
                    user={this.props.user}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    ajaxCallInProgress={this.props.ajaxCallInProgress} 
                
                />

            </div> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    
   
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        
        showSidebarIzquierda: state.showSidebarIzquierda,
        color:state.color,
        permisos:state.permisos,
        form:state.form,
        user:state.user,
        idioma:state.idioma,
        strings:state.strings
        
    }

}

function mapDispatchToProps(dispatch){

	return { 
        cursoActions: bindActionCreators(cursoActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        infoActions: bindActionCreators(infoActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        tagActions: bindActionCreators(tagActions, dispatch)
	};
}


function Parametros(){
    const {id} = useParams();
    const location = useLocation();
    return{
        id
    }
}

export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManagePago));